<button mat-icon-button class="actions-buttons" *ngIf="checkActionsAndActualVersion"
    [disabled]="isCalculating || isDeleting || isOrphan">
    <mat-icon matTooltip="Calculate" class="actions-mat-icons" (click)="openSetSettingsCalculateDialog($event)">
        play_arrow
    </mat-icon>
</button>